export { MyAccountLink as default } from './my-account-link';
